import { __read, __spreadArray, __values } from "tslib";
var SchemaDiffUtils = /** @class */ (function () {
    function SchemaDiffUtils() {
    }
    /**
     * compare collection schema different between newValue and oldValue,compare with indices property
     * @param oldValue
     * @param newValue
     * @returns the difference base on oldValue
     */
    SchemaDiffUtils.collectionDiff = function (oldValue, newValue) {
        if (oldValue.name !== newValue.name) {
            throw new Error('can not compare collection schema with different name');
        }
        var diff = {
            collection: oldValue.name,
        };
        var addIndices = newValue.indices.filter(function (index) {
            return !oldValue.indices.some(function (i) { return i.name === index.name; });
        });
        var delIndices = oldValue.indices.filter(function (index) {
            return !newValue.indices.some(function (i) { return i.name === index.name; });
        });
        if (addIndices.length || delIndices.length) {
            diff.index = {
                added: __spreadArray([], __read(addIndices)),
                deleted: __spreadArray([], __read(delIndices)),
            };
        }
        return diff;
    };
    /**
     * compare database schema by collection schema diff
     * @param oldValue
     * @param newValue
     * @return the difference base on oldValues
     */
    SchemaDiffUtils.databaseDiff = function (oldValue, newValue) {
        var e_1, _a;
        var collectionMap = this.getCompareMap(oldValue, newValue);
        var diff = {
            added: [],
            deleted: [],
            different: [],
        };
        try {
            for (var _b = __values(collectionMap.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var colPair = _c.value;
                // deleted case
                if (colPair.oldValue && !colPair.newValue) {
                    diff.deleted.push(colPair.oldValue);
                    continue;
                }
                // add case
                if (!colPair.oldValue && colPair.newValue) {
                    diff.added.push(colPair.newValue);
                    continue;
                }
                // same name collection schema, compare properties
                if (colPair.oldValue && colPair.newValue) {
                    var schemaDiff = this.collectionDiff(colPair.oldValue, colPair.newValue);
                    if (!schemaDiff.index) {
                        continue;
                    }
                    diff.different.push(schemaDiff);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return diff;
    };
    SchemaDiffUtils.getCompareMap = function (oldValue, newValue) {
        var e_2, _a, e_3, _b;
        var collectionMap = new Map();
        try {
            for (var _c = __values(newValue.collections), _d = _c.next(); !_d.done; _d = _c.next()) {
                var col = _d.value;
                var colPair = collectionMap.get(col.name) || {};
                colPair.newValue = col;
                collectionMap.set(col.name, colPair);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            for (var _e = __values(oldValue.collections), _f = _e.next(); !_f.done; _f = _e.next()) {
                var col = _f.value;
                var colPair = collectionMap.get(col.name) || {};
                colPair.oldValue = col;
                collectionMap.set(col.name, colPair);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return collectionMap;
    };
    return SchemaDiffUtils;
}());
export { SchemaDiffUtils };
//# sourceMappingURL=schema-diff-utils.js.map